import { CircleCircle } from '@calm/evexia-web-sdk';
import createUsercryptApi from '@rhg/libs/api/create-usercrypt-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { invalidateQueryKey, useMutation } from '@rhg/libs/react-query';
import { circleConditionsQueryOptions } from '../use-circle-conditions';

export default function useDeleteCondition(circle?: CircleCircle) {
    const { getAccessTokenSilently } = useAuth();
    const { mutate, mutateAsync, ...otherProps } = useMutation({
        mutationFn: async (conditionId: number) => {
            const api = createUsercryptApi(getAccessTokenSilently);
            const response = await api.usercryptDeleteCondition({
                circleAuthorizationToken: circle!.authorizationJWT,
                recipientId: circle!.recipient.id,
                conditionId,
            });
            return response;
        },
        onSuccess: () => {
            invalidateQueryKey(
                circleConditionsQueryOptions.queryKey(circle!.recipient.id!)
            );
        },
    });

    return {
        deleteCondition: mutate,
        deleteConditionAsync: mutateAsync,
        ...otherProps,
    };
}
